var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-11 col-md-8 col-sm-11"},[_c('div',{staticClass:"text-center alert",class:_vm.type,attrs:{"role":"alert"}},[_c('strong',[_vm._v(_vm._s(_vm.message))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }